import { render, staticRenderFns } from "./Erp6SaleBaseSalesperson.vue?vue&type=template&id=526a1348&scoped=true&"
import script from "./Erp6SaleBaseSalesperson.vue?vue&type=script&lang=js&"
export * from "./Erp6SaleBaseSalesperson.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SaleBaseSalesperson.vue?vue&type=style&index=0&id=526a1348&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526a1348",
  null
  
)

export default component.exports